import { combineReducers } from "redux";
import { assetsState } from "./assetsReducer";

export const assetsReducer = combineReducers({
  assetsState: assetsState
});
